<template>
    <div>
        <mu-badge content="news" secondary/>
        <label>徽章</label>
    </div>
</template>
<script>
export default {
    name: 'badge'
}
</script>



// WEBPACK FOOTER //
// badge.vue?b1dd34d0